import { DefaultButton, IButtonStyles, IIconProps, PrimaryButton } from '@fluentui/react';
import { ISiteHeaderToggleButtonProps } from './SiteHeaderToggleButton';

export interface ISiteHeaderIconToggleButtonProps extends ISiteHeaderToggleButtonProps {
    /** name of fluent registered icon */
    iconName: string;
    darkColor?: boolean;
}
export function SiteHeaderIconToggleButton(props: ISiteHeaderIconToggleButtonProps) {
    const closeLabel = `Close ${props.label}`;
    const openLabel = `Open ${props.label}`;

    let buttonStyles: IButtonStyles | undefined;
    if (props.darkColor) {
        buttonStyles = props.isOpenState ? props.toggleButtonStyles?.darkOpen : props.toggleButtonStyles?.darkClose;
    } else {
        buttonStyles = props.isOpenState ? props.toggleButtonStyles?.lightOpen : props.toggleButtonStyles?.lightClose;
    }

    const iconProps: IIconProps = {
        iconName: props.isOpenState ? 'Cancel' : props.iconName,
        styles: props.iconStyles,
    };
    if (props.darkColor) {
        return (
            <PrimaryButton
                id={props.id}
                onClick={props.onClick}
                styles={buttonStyles}
                iconProps={iconProps}
                title={props.isOpenState ? closeLabel : openLabel}
                ariaLabel={props.isOpenState ? closeLabel : openLabel}
            ></PrimaryButton>
        );
    } else {
        return (
            <DefaultButton
                id={props.id}
                onClick={props.onClick}
                styles={buttonStyles}
                iconProps={iconProps}
                title={props.isOpenState ? closeLabel : openLabel}
                ariaLabel={props.isOpenState ? closeLabel : openLabel}
            ></DefaultButton>
        );
    }
}
